import { axiosClient } from '../../../library/Service/axiosClient';

class UploadOutreachService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};

        return Promise.all([]).then((values) => {
            state.formConfig = {};
            state.data = {};
            state.routeInfo = params;
            state.internal = { gridState: {} };
            return Promise.resolve(state);
        });
    }
}
export default UploadOutreachService;
